<!--
    Component Collection
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">

		<div class="content" :style="{ display: cursor < 0? 'block' : 'none' }">

			<div class="bar darkText largeText">
				<div class="gridLabel bg-collection">{{ model.getDictionary('nav_collection') }}</div>
			</div>

			<div class="collection-grid">
				<div
					class="collection-collection link"
					v-for="(collection, index) in listIntern"
					:key="collection.getID()"
					@click="selectIntern(index)"
				>
					<div class="collection-collection-image zoomable">
						<img v-if="collection.getImage().isImage()"
							:src="collection.getImage().getImageURL(previewImageQuality)" />
						<div v-else 
							v-html="collection.getImage().getMultiMediaHTML(0, 'preview')"></div>	
					</div>
					<div class="collection-collection-label">{{ collection.getName() }}</div>
				</div>
			</div>


			<div v-if="listExtern.length > 0" class="bar darkText largeText spaceAbove">
				<div class="gridLabel bg-collection">{{ model.getDictionary('nav_collection_extern') }}</div>
			</div>
			<div v-if="listExtern.length > 0" class="collection-grid">
				<div
					class="collection-collection link"
					v-for="(collection, index) in listExtern"
					:key="collection.getID()"
					@click="selectExtern(index)"
				>
					<div class="collection-collection-image zoomable">
						<img v-if="collection.getImage().isImage()"
							:src="collection.getImage().getImageURL(previewImageQuality)" />
						<div v-else 
							v-html="collection.getImage().getMultiMediaHTML(0, 'preview')"></div>	
					</div>
					<div class="collection-collection-label">{{ collection.getName() }}</div>
				</div>
			</div>

		</div>

		<collection-detail v-if="cursor >= 0"
			:collection="list [cursor]"
			:args="args.concat([list [cursor].getURLTerm()])"
			:level="1"
		></collection-detail>
	</div>
</template>

<script>

	import Vue from "vue";
	import { model } from "./../model/Model.js";
	import { ListWithCursor } from "./../mixin/ListWithCursor.js";
	import CollectionDetail from "./CollectionDetail.vue";

	export default {
		mixins: [ ListWithCursor ],
		components: { CollectionDetail },

		data: function() {
			return {
				// expose model for translations
				model: model,
				// source of the preview images
				previewImageQuality: 'small'
			}
		},

		created: function() {
			this.list = model.getCollections().getList().filter(x => { return x.getID() != 0});
			this.listIntern = this.list.filter(x => { return x.getIsExtern() == false});
			this.listExtern = this.list.filter(x => { return x.getIsExtern() == true});

			this.previewImageQuality = Vue.prototype.$previewImageQuality;
		},

		methods: {

			selectIntern: function(idx) {
				let id = this.listIntern [idx].getID();
				let index = 0;
				for (let i = 0; i < this.list.length; i++) {
					if (this.list [i].getID() == id) {
						index = i;
						break;
					}
				}
				this.select(index);
			},

			selectExtern: function(idx) {
				let id = this.listExtern [idx].getID();
				let index = 0;
				for (let i = 0; i < this.list.length; i++) {
					if (this.list [i].getID() == id) {
						index = i;
						break;
					}
				}
				this.select(index);
			}
		}

	};
</script>


<style>

@media (min-width: 1000px) {

	div.spaceAbove {
		margin-top: 2rem;
	}

	div.collection-grid {
		position: relative;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	div.collection-collection {
		width: 20rem;
		margin-bottom: 2rem;
		margin-right: 2rem;
	}

	div.collection-collection-image {
		width: 20rem;
		height: 10rem;
		overflow: hidden;
	}

	div.collection-collection-image img, div.collection-collection-image div {
		object-fit: cover;
		object-position: center;
		width: 20rem;
		height: 10rem;
	}

	div.collection-collection-label {
		font-size: 1rem;
		color: white;
		background-color: #92a8b4;
		padding: 0.3rem 2.4rem 0.3rem 2.4rem;
	}

}

@media (max-width: 1000px) {
	
	div.collection-grid {
		position: relative;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	div.collection-collection {
		width: 20rem;
		margin-bottom: 2rem;
		margin-right: 2rem;
	}

	div.collection-collection-image {
		width: 20rem;
		height: 10rem;
		overflow: hidden;
	}

	div.collection-collection-image img, div.collection-collection-image div {
		object-fit: cover;
		object-position: center;
		width: 20rem;
		height: 10rem;
	}

	div.collection-collection-label {
		font-size: 1rem;
		color: white;
		background-color: #92a8b4;
		padding: 0.3rem 2.4rem 0.3rem 2.4rem;
	}

}

</style>